import { ReactElement } from "react"
import { Link } from "react-router-dom"
import { Loading } from "@wfp/ui"
import { useGetLinkedFormsQuery } from "services/household/xlsFormSchemas"
import ErrorState from "components/Shared/EmptyState/ErrorState"

type Props = {
  xlsFormId: number
}

const BaseXlsFormLinked = ({ xlsFormId }: Props): ReactElement => {
  const { data: linkedForms, isLoading, error } = useGetLinkedFormsQuery({ xlsFormId })

  if (isLoading) return <Loading small />
  if (!linkedForms?.length)
    return (
      <div className="p-3">
        <p className="font-bold mb-2">No linked forms found</p>
      </div>
    )

  if (error) return <ErrorState />

  return (
    <div className="p-3">
      <p className="font-bold mb-2">This base XLSForm is linked to these CO XLSForms:</p>
      {linkedForms?.map(form => (
        <div key={form.value} className="mb-1">
          <Link to={`/household/xlsFormSchema/${form.value}#details`} className="text-brand-01">
            {form.name}
          </Link>
        </div>
      ))}
    </div>
  )
}

export default BaseXlsFormLinked
